import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.timers.js";
import request from "@/utils/request";
import ajaxUrl from "@/api/index";
import appConfig from "@/app.config";
import { Toast } from "vant";
import { getUrlParams, setWebTitle } from "@/utils/utils";
export default {
  data: function data() {
    return {
      wxAppid: this.$route.query.appid,
      //公众号appid
      code: "",
      wxUserInfo: {},
      //公众号用户授权后的数据
      miniAppUserInfo: {},
      //小程序使用code换回的数据
      miniAppUrl: "" //小程序URL
    };
  },
  created: function created() {
    setWebTitle("减重打卡");
    this.init();
  },
  methods: {
    init: function init() {
      var _this2 = this;
      this.showLoading("授权中");
      this.initPageUrl().then(function (res) {
        _this2.getWxInfo();
      });
    },
    initPageUrl: function initPageUrl() {
      var _this = this;
      var p = new Promise(function (resolve, reject) {
        var a = window.location.href;
        var obj = a.split("#")[0];
        // let wxAppid = obj.split("/?")[0].split("/")[3]; //公众号appid
        var wxAppid = _this.$route.query.appid; //公众号appid
        var wxObj = getUrlParams(obj);
        var code = wxObj.code;
        var state = wxObj.state;
        if (code) {
          localStorage.setItem("code", code);
          localStorage.setItem("state", state);
          localStorage.setItem("wxAppid", wxAppid);
          var b = a.split("?code=");
          var c = b[1].split("#")[1];
          var d = b[0] + "#" + c;
          // reject("need refresh page");
          location.href = d;
        } else {
          resolve(true);
        }
      });
      return p;
    },
    //获取公众号的openid,从；链接里获取
    getWxInfo: function getWxInfo() {
      var _this3 = this;
      request({
        method: "post",
        url: ajaxUrl.getAauth2AccessToken,
        data: {
          appId: localStorage.wxAppid || "",
          code: this.code || localStorage.code || "",
          type: 0
        }
      }).then(function (res) {
        console.log(res);
        if (res.status == 0) {
          _this3.wxUserInfo = res.data;
          _this3.getMiniAppScheme();
        }
      });
    },
    //获取小程序的openid
    getMiniappInfo: function getMiniappInfo() {
      var _this4 = this;
      request({
        method: "post",
        url: ajaxUrl.getWxMaUser,
        data: {
          appId: appConfig.miniAppId,
          code: this.code || localStorage.code || "",
          type: 1
        }
      }).then(function (res) {
        console.log(res);
        if (res.status == 0) {
          _this4.miniAppUserInfo = res.data;
          _this4.getUserInfo();
        }
      });
    },
    //患者详情
    getUserInfo: function getUserInfo() {
      var _this5 = this;
      request({
        method: "post",
        url: ajaxUrl.getRegisterPatientInfo,
        data: {
          appId: appConfig.miniAppId,
          maOpenId: this.miniAppUserInfo.openid,
          mpOpenId: this.wxUserInfo.openid
        }
      }).then(function (res) {
        console.log(res);
        _this5.hideLoading();
        if (res.status == 0) {
          _this5.miniAppUserInfo = res.data;
          if (_this5["this"].miniAppUrl != "") {
            setTimeout(function () {
              location.href = _this5.miniAppUrl;
            }, 500);
          }
        }
      });
    },
    //获取小程序URL
    getMiniAppScheme: function getMiniAppScheme() {
      request({
        method: "post",
        url: ajaxUrl.getScheme,
        data: {
          appId: appConfig.miniAppId || "",
          //小程序的appid
          jumpWxa: {
            path: "",
            query: "wxOpenId=".concat(this.wxUserInfo.openId) //公众号的openid
          }
        }
      }).then(function (res) {
        console.log(res);
        if (res.status == 0) {
          location.href = res.data.openlink;
        }
      });
    }
  }
};